<template>
  <!-- 通用栏目菜单-左侧 -->
  <div class="nav-columns" role="tablist" v-if="visible">
    <div class="breadCrumb">{{ columnsTitle }}</div>
    <b-card no-body v-for="(item, i) in columnsList" v-bind:key="i">
      <template v-if="item.children && item.children.length != 0">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button variant="link" block v-b-toggle="'accordion-' + i">
            <b-icon icon="chevron-right"></b-icon>
            {{ item.name }}</b-button
          >
        </b-card-header>
      </template>
      <template v-else>
        <b-card-header header-tag="header" class="p-1" role="tab">
          <router-link :to="item.path || ''"
            ><b-button
              variant="link"
              class="textOVerOdd"
              :style="contentCurrentPath === item.path ? 'color:#000' : ''"
              ><p class="textOVerOdd" style="margin:0">
                {{ item.name }}
              </p></b-button
            ></router-link
          >
        </b-card-header>
      </template>
      <template v-if="item.children && item.children.length != 0">
        <b-collapse
          :visible="item.path.includes(contentCurrentPath)"
          :id="`accordion-${i}`"
          accordion="my-accordion"
          role="tabpanel"
        >
          <div
            class="breadCrumbSub"
            v-for="(row, s) in item.children"
            v-bind:key="s"
            :id="`ids${row.timeline_id}`"
          >
            <router-link :to="row.href">
              <b-button
                variant="link"
                :style="row.href === path ? 'color:#000' : ''"
                ><p class="textOVerOdd" style="margin:0">
                  {{ row.title }}
                </p></b-button
              >
            </router-link>
          </div>
        </b-collapse>
      </template>
    </b-card>
  </div>
</template>

<script>
export default {
  props:{
    visible:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      path: "", // 三级菜单样式选中
      columnsList: [],
      columnsTitle: "",
      columnsSubList: {},
      contentCurrentPath: "",
    };
  },
  created() {
    this.path = this.$route.path;
    this.updateColumns();
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener("scroll", this.handleScroll);
    });
  },
  methods: {
    getlocal() {
      setTimeout(() => {
        let anel = document.getElementById(`ids${this.$route.params.id}`);
        if (anel) {
          anel.scrollIntoView();
        }
      }, 100);
    },
    updateColumns() {
      // this.widthHeight = window.body.scrollHeight;
      // const menuList = this.$t("menuList");
      const menuList = this.$store.state.global.menuList;
      const currPath = this.$route.path;
      let menuSubTitle = "";
      menuList.map((d) => {
        const { path = "" } = d;
        // 一级菜单
        if (currPath.includes(path.split("/")[1])) {
          const { children = [], ...obj } = d;
          this.columnsTitle = obj.name;
          menuSubTitle = obj.name;
          this.columnsList = children || [];
          // 二级菜单
          children.map((f) => {
            if (currPath.includes(f.path)) {
              this.contentCurrentPath = f.path;
              menuSubTitle = f.name;
              // 判断是否显示默认第一个数据
              if (f.children && f.children.length != 0) {
                f.children.map((s) => {
                  if (currPath === s.href) {
                    menuSubTitle = s.title;
                  }
                });
                currPath.split("/").length === 3 &&
                  this.$router.push({ path: f.children[0].href });
              }
            }
          });
        }
      });
      // this.$store.commit("updateColumnsTitle", menuSubTitle);
      this.$emit("updateColumnsTitle", menuSubTitle);
    },
  },
  watch: {
    $route() {
      this.path = this.$route.path;
      this.updateColumns();
    },
    /* eslint-disable */
    columnsList: function() {
      this.$nextTick(() => {
        this.getlocal();
      });
    },
  },
};
</script>

<style scoped>
.nav-columns {
  height: calc(100vh - 237px - 100px);
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAM0lEQVQYV2NkQAM3P3/7r87LxYgsDBLDEMCmCCQGV4jLJJhGsEJCikBqGIlRBFY4nDwDAIeHT431w+WIAAAAAElFTkSuQmCC);
}
.nav-columns .breadCrumb {
  padding: 16px 30px 16px 20px;
  background: #fafafa;
  border-bottom: 1px solid #e4e4e4;
  display: block;
  position: relative;
  color: #999;
  font-size: 16px;
  font-weight: bold;
  line-height: 18px;
}
.nav-columns .card {
  border: none;
}
.nav-columns .btn {
  text-align: left;
  font-size: 14px;
  font-weight: bold;
}
.breadCrumbSub {
  padding: 5px 20px;
  background: #fafafa;
  display: block;
  position: relative;
  color: #999;
  font-size: 14px;
  line-height: 18px;
}
.breadCrumbSub::after {
  content: "";
  width: calc(100% - 20px);
  height: 1px;
  background: #eee;
  position: absolute;
  bottom: 0;
  left: 20px;
}
.breadCrumbSub .btn {
  font-weight: normal;
}
</style>
